<template>
  <div
    v-if="onHoldHistories.length"
  >
    <p
      class="history-title"
    >
      {{ $t('tenantProjects.greenFitOut.onHoldHistoryTitle') }}
    </p>

    <HKLTable
      :dataSource="onHoldHistories"
      :columns="onHoldColumns"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, unref, getCurrentInstance } from 'vue-demi'
import { GREEN_FITOUT_HISTORY_ACTION_TYPE } from './consts'
import dateUtil from '@/utils/dateUtil'
import { useCurrentGreenFitout } from './hook'
import HKLTable from '@/controls/Table/HKLTable'

export default {

  components: {
    HKLTable,
  },

  setup () {
    const { proxy } = getCurrentInstance()
    const currentGreenFitout = useCurrentGreenFitout()

    const onHoldHistories = computed(() => {
      const histories = lodash.orderBy(unref(currentGreenFitout).histories, 'createdAt', 'desc')
      const filterHistories = histories.filter(history => history.actionType === GREEN_FITOUT_HISTORY_ACTION_TYPE.ON_HOLD && history.onHold)
      const formattedData = filterHistories.map(item => {
        return {
          originItem: item,
          date: dateUtil.format(item.createdAt, 'DD MMM YY HH:mm'),
          actionBy: lodash.get(item, 'createdBy.displayName'),
          comment: lodash.get(item, 'comment'),
        }
      })
      return formattedData
    })
    const onHoldColumns = [
      {
        title: proxy.$t('table.header.date'),
        dataIndex: 'date',
      },
      {
        title: proxy.$t('table.header.actionBy'),
        dataIndex: 'actionBy',
      },
      {
        title: proxy.$t('table.header.comment'),
        dataIndex: 'comment',
      },

    ]
    return {
      onHoldColumns,
      onHoldHistories,

    }
  },
}
</script>
<style lang="scss" scoped>
.history-title {
  margin-top: 10px;
  font-weight: bold;
}
.hkl-table {
  margin-left: 0px;
}
</style>
